var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationPopupErrorGraphic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 275.805,
    height: 258.196,
    viewBox: "0 0 275.805 258.196",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.136,
    y1: 1.084,
    x2: 0.58,
    y2: 0.086,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#201b59",
    stopOpacity: 0.914
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#fc0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.122,
    y1: 0.339,
    x2: 0.816,
    y2: 0.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -0.556,
    y1: -1.922,
    x2: -1.63,
    y2: -0.878,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.265,
    stopColor: "#201b59",
    stopOpacity: 0.914
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    stopColor: "#ff735f",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.822,
    y1: 1.348,
    x2: 0.247,
    y2: 0.055,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.811,
    y1: 0.646,
    x2: -0.035,
    y2: -0.005,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.004,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.551,
    stopColor: "#fff",
    stopOpacity: 0.302
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_933",
    "data-name": "Path 933",
    d: "M390.955,311.258a4.1,4.1,0,0,1,1.709-3.168c1.509-.884,3.522-.146,5.278-.474,4.933-.923,4.9-7.809,4.8-11.6q-.1-3.619-.324-7.234a4.011,4.011,0,0,0-.423-1.851,2.735,2.735,0,0,0-3.072-.957c-2.159.617-3.371,2.949-3.754,5.162s-.2,4.513-.775,6.682a3.943,3.943,0,0,1-.48,1.163,2.671,2.671,0,0,1-1.08.922,2.11,2.11,0,0,1-2.006-.029c-.681-.437-.568-.987-.564-1.651a20.374,20.374,0,0,0-.2-2.418c-.209-1.813-.391-3.63-.561-5.447-.335-3.573-.626-7.149-1-10.719a12.23,12.23,0,0,0-1.173-4.786c-3.534-6.344-8.917-.771-9.412,3.855-1.126,10.525,4.356,20.45,3.9,30.9a3.144,3.144,0,0,1-.243,1.293c-.825,1.644-3.462,1.357-4.681.409-1.911-1.487-1.227-4.708-1.229-6.646,0-1.582-.508-3.369-2.038-4.11-1.735-.84-4,.167-4.988,1.718-1.276,2-1.134,5.428-.943,7.654a9.393,9.393,0,0,0,1.465,4.6,5.8,5.8,0,0,0,4.285,2.537c1.02.061,2.184-.155,2.958.456.943.744.6,2.105.642,3.243.074,2.259,2,4.19,4.244,5.14a21.9,21.9,0,0,0,7.25,1.255c2.094-3.36,2.234-7.234,2.343-10.99A40.356,40.356,0,0,1,390.955,311.258Z",
    transform: "translate(-367.563 -272)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_14272",
    "data-name": "Group 14272",
    transform: "translate(1.001 0.77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_388",
    "data-name": "Rectangle 388",
    d: "M18.792,0H65.634A18.792,18.792,0,0,1,84.426,18.792V37.583a0,0,0,0,1,0,0H18.792A18.792,18.792,0,0,1,0,18.792v0A18.792,18.792,0,0,1,18.792,0Z",
    transform: "translate(29.736 111.26)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_890",
    "data-name": "Path 890",
    d: "M238.558,301.7c19.222-6.779,37.818-18.371,49.99-35.264,14.89-20.666,13.615-44.091,16.662-68.235,1.238-9.812,7.808-15.453,11.717-24.155,8.247-18.355,5.333-45.98-12.009-58.449-10.682-7.679-21-8.516-26.753-21.871-3.18-7.384-5.04-15.512-9.978-21.857-7.15-9.186-19.287-12.8-30.786-14.61-13.373-2.108-26.435-1.64-39.848-2.038-14.3-.424-28.8-.038-42.678,3.758-18.837,5.151-39.539,18.638-42.827,39.173-1.409,8.8.437,18.2-2.907,26.463-5.032,12.437-18.436,16.655-28.418,24-10.717,7.889-17.688,20.2-20.747,33-5.213,21.812-1.37,46.007,8.774,65.81,10.86,21.2,28.5,39.235,49.891,49.842,16.758,8.308,39.909,10.757,58.808,11.922C198.1,310.472,219.125,308.557,238.558,301.7Z",
    transform: "translate(-53.038 -55.089)",
    fill: "#eee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_891",
    "data-name": "Path 891",
    d: "M303.178,243.308c-.12-31.158-8.739-61.089-34.092-81.166C237.8,137.37,194.074,137.692,162.1,160.8c-20.911,15.114-35.574,37.856-43.8,62.312s-10.344,50.617-9.468,76.4l190.38.595q1.194-13.127,2.386-26.253C302.51,263.817,303.217,253.553,303.178,243.308Z",
    transform: "translate(-68.47 -81.849)",
    fill: "#d2c8d9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_389",
    "data-name": "Rectangle 389",
    d: "M18.792,0H65.634A18.792,18.792,0,0,1,84.426,18.792V37.583a0,0,0,0,1,0,0H18.792A18.792,18.792,0,0,1,0,18.792v0A18.792,18.792,0,0,1,18.792,0Z",
    transform: "translate(40.196 107.773)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_390",
    "data-name": "Rectangle 390",
    d: "M24.854,0H90.621a24.854,24.854,0,0,1,24.854,24.854V49.709a0,0,0,0,1,0,0H24.854A24.854,24.854,0,0,1,0,24.854v0A24.854,24.854,0,0,1,24.854,0Z",
    transform: "translate(78.11 33.674)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_391",
    "data-name": "Rectangle 391",
    d: "M17.017,0H49.56A17.017,17.017,0,0,1,66.577,17.017v0A17.017,17.017,0,0,1,49.56,34.034H0a0,0,0,0,1,0,0V17.017A17.017,17.017,0,0,1,17.017,0Z",
    transform: "translate(175.174 87.957)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    opacity: 0.75
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1359",
    "data-name": "Group 1359",
    transform: "translate(85.061 104.521)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_892",
    "data-name": "Path 892",
    d: "M174.423,322.15c-1.326,4.55-2.468,9.824.218,13.729,3.234,4.7,10.659,4.649,15.321,1.356s7.189-8.775,9.348-14.059c3.637-8.9,6.842-18.073,8.107-27.607.739-5.576.1-12.5-4.966-14.946-7.784-3.769-14.423,2.239-16.943,8.825C181.39,300.2,177.645,311.089,174.423,322.15Z",
    transform: "translate(-173.008 -227.511)",
    fill: "#ff735f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_893",
    "data-name": "Path 893",
    d: "M202.213,253.05a47.816,47.816,0,0,0-5.371,6.913,91.47,91.47,0,0,0-5.389,10.716c-.6,1.278-5.667,12.384-4.536,13.193,6.365,4.55,12.619,9.52,19.91,12.316.245.094-1.146,5.438-1.275,5.949q-.744,2.965-1.348,5.961c-.8,3.965-1.424,7.994-2.122,11.989q-.583,3.336-1.137,6.677c-.166,1,31.524,3.109,34.393,3.151,8.383.123,21.558,2.476,26.647-6.082a23.1,23.1,0,0,0,2.346-6.65,164.215,164.215,0,0,0,4.163-41.147,43.858,43.858,0,0,0-1.036-9.656c-1.148-4.583-3.552-8.694-6.067-12.646-2.293-3.6-5.905-5.6-9.737-7.429-11.538-5.521-25.425-7.3-37.13-2.14A38.072,38.072,0,0,0,202.213,253.05Z",
    transform: "translate(-177.167 -215.903)",
    fill: "#f5ba00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_894",
    "data-name": "Path 894",
    d: "M281.47,297.388l-.949,2.193c-1.216,2.811-4.276,7.68-4.276,10.761a28.991,28.991,0,0,0-1.278,13.876,37.6,37.6,0,0,0,1.509,5.421,22.557,22.557,0,0,0,3.027,6.389c1.278,1.7,4.331,4.393,6.693,3.474,2.465-.959,4.3-5.432,5.245-7.642,5.591-13.134,7.806-27.563,9.168-41.691a7.343,7.343,0,0,0-2.2-6.792c-1.225-1.527-2.644-3.126-4.57-3.469a5.715,5.715,0,0,0-5,2.013,16.882,16.882,0,0,0-2.781,4.859Z",
    transform: "translate(-203.755 -227.628)",
    fill: "#ff735f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_895",
    "data-name": "Path 895",
    d: "M291.975,285.426c-1.077-.3-16.109-3.953-16.143-2.1q.167-12.244,1.353-24.446a26.892,26.892,0,0,1,1.531-7.623,9.649,9.649,0,0,1,5.189-5.534,10.047,10.047,0,0,1,5.675-.211,16.652,16.652,0,0,1,12.348,11.995,30.86,30.86,0,0,1,.614,7.729c-.071,7.7-.641,15.375-1.1,23.04C298.216,288.2,295.06,286.293,291.975,285.426Z",
    transform: "translate(-204.126 -217.146)",
    fill: "#f5ba00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_896",
    "data-name": "Path 896",
    d: "M302.579,240.027a10.218,10.218,0,0,1,.384,2.135c.315,4.9-2.9,8.99-6.133,12.3-1.266,1.3-3.051,2.191-4.2,3.539-1.307,1.538-1.248,4.077-3.52,4.762a2.758,2.758,0,0,1-3.183-3.9,20.375,20.375,0,0,1,1.709-4.138,8.569,8.569,0,0,1,2.834-2.124,8,8,0,0,0,3.711-5.474c.591-4.121-.008-8.769,1.428-12.707a4.411,4.411,0,0,1,1.126-1.836,2.1,2.1,0,0,1,2.014-.5c1.008.349,1.4,1.527,1.755,2.534C301.142,236.432,302.058,238.188,302.579,240.027Z",
    transform: "translate(-207.098 -213.146)",
    fill: "#db6352"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_897",
    "data-name": "Path 897",
    d: "M292.559,299.7c.469,8.807.361,17.78-2.035,26.333-.714,2.551-1.895,6.209-4.367,7.633-2.789,1.608-7.165.311-9.753-1.172a12.643,12.643,0,0,1-4.429-3.832c-1.707-2.6-1.8-5.923-1.6-9.03.535-8.347,2.605-16.133,4.22-24.268q2.641-13.3,6.18-26.407c1.007-3.729,2.3-6.505,5.422-8.854,2.223-1.675,5.953-3.891,6.159.464C292.97,273.578,291.864,286.632,292.559,299.7Z",
    transform: "translate(-202.451 -221.026)",
    fill: "#db6352"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_898",
    "data-name": "Path 898",
    d: "M251.446,241.454a5.2,5.2,0,0,0-.623,1.475,6.1,6.1,0,0,0,.007,2.052c.638,5.093,1.7,10.133,7.161,11.725a15.528,15.528,0,0,0,11.409-1.17,12.046,12.046,0,0,0,2.95-2.135,5.061,5.061,0,0,0,1.484-3.252c3.668.8,7.46-2.929,9.37-5.611,4.377-6.146,5.827-13.855,5.162-21.281a9.99,9.99,0,0,0-1.545-5.2,10.77,10.77,0,0,0-2.946-2.425c-5.019-3.211-10.365-3.386-15.848-.852-4.982,2.3-8.439,7.228-10.777,12.012-.978,2-1.15,4.637-1.934,6.78a41.087,41.087,0,0,1-3.473,7.221C251.71,241.013,251.574,241.232,251.446,241.454Z",
    transform: "translate(-196.531 -207.41)",
    fill: "#ff735f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_899",
    "data-name": "Path 899",
    d: "M259.708,213.2a15.269,15.269,0,0,1,4.847-6.292c3.769-2.616,9.223-2.128,13.467-1.177,2.443.547,4.888,1.613,7.428,1.584,2.289-.027,4.661-2.311,6.88-1.542A3.124,3.124,0,0,1,294.318,208c.371,1.67-.666,3.281-1.469,4.791a24.454,24.454,0,0,1-1.979,3.536,7.082,7.082,0,0,1-4.564,2.77,8.3,8.3,0,0,1-1.812-.057c-3.6-.377-6.628-1.381-9.386,1.469-1.877,1.937-2.812,4.591-4.192,6.864a4.093,4.093,0,0,1-1.271,1.446,8.127,8.127,0,0,1-2.475.633c-3.577.83-5.929,6.825-9.709,5.535-3.24-1.105-2.5-4.049-1.223-6.379,1.593-2.9,1.289-6.419,1.77-9.691A21.951,21.951,0,0,1,259.708,213.2Z",
    transform: "translate(-197.867 -204.969)",
    fill: "#19034d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_900",
    "data-name": "Path 900",
    d: "M262.207,235.893a8.892,8.892,0,0,0-1.545,3.792,7.2,7.2,0,0,0,.013,3.518,3.283,3.283,0,0,0,2.434,2.34,3.223,3.223,0,0,0,2.562-.844c1.668-1.457,3.626-5.935,3.15-8.218C268.14,233.211,263.851,233.782,262.207,235.893Z",
    transform: "translate(-199.47 -213.806)",
    fill: "#ff735f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_901",
    "data-name": "Path 901",
    d: "M266.476,238.362a3.731,3.731,0,0,0-2.058,2.008,11.062,11.062,0,0,0-.766,2.843",
    transform: "translate(-200.44 -215.075)",
    fill: "none",
    stroke: "#19034d",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_904",
    "data-name": "Path 904",
    d: "M271.157,336.535c-.357,2.273-.636,4.557-.783,6.854-.2,3.106-.106,6.427,1.6,9.03a12.644,12.644,0,0,0,4.429,3.832c2.589,1.483,6.965,2.78,9.753,1.172,2.472-1.425,3.653-5.082,4.367-7.633a62.572,62.572,0,0,0,2.1-13.254Z",
    transform: "translate(-202.451 -244.785)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_905",
    "data-name": "Path 905",
    d: "M228.338,312.413l-3.812-10.866c.094.268-.681,1.479-.812,1.767q-.429.939-.854,1.882c-.586,1.291-1.172,2.582-1.772,3.867a71.739,71.739,0,0,1-3.656,7.224,10.083,10.083,0,0,1-3.064-1.65c-.379,2.2-1.068,4.269-1.509,6.461-.228,1.135-.436,2.274-.646,3.412-.107.578-.213,1.156-.324,1.734-.045.234-.13,1.471-.314,1.579a73.6,73.6,0,0,0,16.141-12.786,2.665,2.665,0,0,0,.847-1.386A2.7,2.7,0,0,0,228.338,312.413Z",
    transform: "translate(-184.68 -234.196)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_908",
    "data-name": "Path 908",
    d: "M273.331,261.881q-.121,2.733-.2,5.469-.04,1.425-.065,2.85c0,.173-.047.5-.06.831a18.348,18.348,0,0,0,3.3-.941,7.128,7.128,0,0,0,3.669-3.117,10.021,10.021,0,0,0,.633-1.84C278.1,264.622,275.216,263.665,273.331,261.881Z",
    transform: "translate(-203.27 -222.192)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_909",
    "data-name": "Path 909",
    d: "M223.959,359.119c9.444,1.126,19.855,2.351,28.938-.329a36.994,36.994,0,0,0-4.84-5.969,12.415,12.415,0,0,0-6.744-3.448,16.528,16.528,0,0,0-4.046.123c-2.351.287-5.4,1.509-7.716,1.319-1.969-.162-4.538-1.849-6.4-2.587-12.644-5-27.642-11.816-41.463-8.181-6.99,1.838-11.194,7.675-6.376,14.249,2.691,3.672,7.045,2.986,11.287,3.057,11.452.192,22.941.1,34.336,1.408Q222.427,358.935,223.959,359.119Z",
    transform: "translate(-173.079 -245.538)",
    fill: "#ff735f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_911",
    "data-name": "Path 911",
    d: "M207.465,332.9c-.095-.159-.188-.319-.28-.48-.658-1.078-1.276-2.18-1.867-3.3a20.239,20.239,0,0,1-2.755,2.412,23.751,23.751,0,0,0-3.614,3.144c-.68.705-1.333,1.435-1.979,2.171q.257.6.5,1.2c.082.2.171.4.257.6q.657-.222,1.325-.416c2.247-.651,5.2-1.54,7.7-1.184.131-1.363.663-2.659.772-4.021C207.5,332.981,207.484,332.939,207.465,332.9Z",
    transform: "translate(-180.26 -242.54)",
    fill: "url(#linear-gradient-4)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1361",
    "data-name": "Group 1361",
    transform: "translate(71.136 25.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_392",
    "data-name": "Rectangle 392",
    d: "M24.854,0H90.621a24.854,24.854,0,0,1,24.854,24.854V49.709a0,0,0,0,1,0,0H24.854A24.854,24.854,0,0,1,0,24.854v0A24.854,24.854,0,0,1,24.854,0Z",
    transform: "translate(0)",
    fill: "#9d7eb4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1360",
    "data-name": "Group 1360",
    transform: "translate(27.079 13.683)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_915",
    "data-name": "Path 915",
    d: "M206.865,126.986h-2.129v3.741h-5.157v-3.741h-7.708v-3.835L199.91,111.4h4.827v11.689h2.129Zm-7.286-3.9v-2.248q0-.635.047-1.712a10.952,10.952,0,0,1,.073-1.131h-.145a14.069,14.069,0,0,1-1.018,1.9l-2.142,3.186Z",
    transform: "translate(-191.871 -111.118)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_916",
    "data-name": "Path 916",
    d: "M237.053,120.968q0,5.131-1.719,7.517a6.051,6.051,0,0,1-5.262,2.387,5.977,5.977,0,0,1-5.223-2.493q-1.758-2.492-1.759-7.411,0-5.156,1.719-7.563A6.031,6.031,0,0,1,230.071,111a5.97,5.97,0,0,1,5.216,2.506Q237.053,116.01,237.053,120.968Zm-8.767,0a16.5,16.5,0,0,0,.41,4.509q.41,1.229,1.375,1.229t1.382-1.269a16.792,16.792,0,0,0,.4-4.469,16.86,16.86,0,0,0-.41-4.5q-.41-1.289-1.375-1.289t-1.375,1.243A16.791,16.791,0,0,0,228.286,120.968Z",
    transform: "translate(-201.319 -110.998)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_917",
    "data-name": "Path 917",
    d: "M267.9,126.986h-2.128v3.741h-5.156v-3.741h-7.709v-3.835l8.039-11.755h4.826v11.689H267.9Zm-7.285-3.9v-2.248q0-.635.046-1.712a10.929,10.929,0,0,1,.073-1.131h-.145a14,14,0,0,1-1.018,1.9l-2.142,3.186Z",
    transform: "translate(-210.342 -111.118)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1363",
    "data-name": "Group 1363",
    transform: "translate(48.565 86.852)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_393",
    "data-name": "Rectangle 393",
    d: "M18.792,0H65.634A18.792,18.792,0,0,1,84.426,18.792V37.583a0,0,0,0,1,0,0H18.792A18.792,18.792,0,0,1,0,18.792v0A18.792,18.792,0,0,1,18.792,0Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1362",
    "data-name": "Group 1362",
    transform: "translate(22.888 15.435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_918",
    "data-name": "Path 918",
    d: "M157.19,209.226a3.715,3.715,0,0,1-2.717-.96,3.632,3.632,0,0,1-.978-2.716,4,4,0,0,1,.9-2.8,3.222,3.222,0,0,1,2.5-.988,3.171,3.171,0,0,1,2.376.87,3.287,3.287,0,0,1,.849,2.4v.953h-4.641a1.884,1.884,0,0,0,.5,1.307,1.743,1.743,0,0,0,1.3.47,5.409,5.409,0,0,0,1.229-.135,6.188,6.188,0,0,0,1.21-.432v1.52a4.609,4.609,0,0,1-1.1.383A6.941,6.941,0,0,1,157.19,209.226Zm-.277-6.064a1.245,1.245,0,0,0-.978.4,1.831,1.831,0,0,0-.406,1.123h2.755a1.636,1.636,0,0,0-.38-1.123A1.285,1.285,0,0,0,156.913,203.163Z",
    transform: "translate(-153.495 -201.765)",
    fill: "#652f8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_919",
    "data-name": "Path 919",
    d: "M171.2,201.765a3.13,3.13,0,0,1,.663.059l-.148,1.84a2.271,2.271,0,0,0-.579-.064,2.086,2.086,0,0,0-1.465.483,1.748,1.748,0,0,0-.524,1.352V209.1h-1.963v-7.2h1.487l.29,1.211h.1a2.709,2.709,0,0,1,.9-.976A2.23,2.23,0,0,1,171.2,201.765Z",
    transform: "translate(-157.637 -201.765)",
    fill: "#652f8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_920",
    "data-name": "Path 920",
    d: "M181.675,201.765a3.13,3.13,0,0,1,.663.059l-.148,1.84a2.271,2.271,0,0,0-.58-.064,2.082,2.082,0,0,0-1.464.483,1.745,1.745,0,0,0-.524,1.352V209.1h-1.964v-7.2h1.487l.29,1.211h.1a2.708,2.708,0,0,1,.9-.976A2.23,2.23,0,0,1,181.675,201.765Z",
    transform: "translate(-160.807 -201.765)",
    fill: "#652f8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_921",
    "data-name": "Path 921",
    d: "M194.484,205.486a3.866,3.866,0,0,1-.927,2.748,3.363,3.363,0,0,1-2.582.992,3.611,3.611,0,0,1-1.829-.454,3.019,3.019,0,0,1-1.216-1.3,4.374,4.374,0,0,1-.425-1.983,3.845,3.845,0,0,1,.921-2.743,3.38,3.38,0,0,1,2.587-.978,3.631,3.631,0,0,1,1.829.451,3,3,0,0,1,1.216,1.294A4.332,4.332,0,0,1,194.484,205.486Zm-4.976,0a3.023,3.023,0,0,0,.351,1.616,1.256,1.256,0,0,0,1.143.547,1.234,1.234,0,0,0,1.13-.544,3.065,3.065,0,0,0,.345-1.619,2.975,2.975,0,0,0-.348-1.6,1.478,1.478,0,0,0-2.272,0A2.964,2.964,0,0,0,189.507,205.486Z",
    transform: "translate(-163.787 -201.765)",
    fill: "#652f8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_922",
    "data-name": "Path 922",
    d: "M205.745,201.765a3.13,3.13,0,0,1,.663.059l-.148,1.84a2.271,2.271,0,0,0-.58-.064,2.085,2.085,0,0,0-1.464.483,1.745,1.745,0,0,0-.524,1.352V209.1h-1.964v-7.2h1.488l.289,1.211h.1a2.7,2.7,0,0,1,.9-.976A2.23,2.23,0,0,1,205.745,201.765Z",
    transform: "translate(-168.092 -201.765)",
    fill: "#652f8c"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_923",
    "data-name": "Path 923",
    d: "M327.358,307.227,309.3,239.834a22.072,22.072,0,0,0-20.84-16.353h0c-18.627-.405-29.343,21.023-17.848,35.685,18.883,24.088,39.763,51.149,39.763,51.149Z",
    transform: "translate(-118.838 -106.048)",
    opacity: 0.49,
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1366",
    "data-name": "Group 1366",
    transform: "translate(187.727 79.582)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_394",
    "data-name": "Rectangle 394",
    d: "M15.412,0H47.477A15.412,15.412,0,0,1,62.889,15.412v0A15.412,15.412,0,0,1,47.477,30.825H0a0,0,0,0,1,0,0V15.412A15.412,15.412,0,0,1,15.412,0Z",
    transform: "translate(0 0)",
    fill: "#997bb0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1365",
    "data-name": "Group 1365",
    transform: "translate(20.508 13.792)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1364",
    "data-name": "Group 1364"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_141",
    "data-name": "Ellipse 141",
    cx: 1.62,
    cy: 1.62,
    rx: 1.62,
    ry: 1.62,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_924",
    "data-name": "Path 924",
    d: "M366.235,190.6a1.62,1.62,0,1,1-1.62-1.62A1.62,1.62,0,0,1,366.235,190.6Z",
    transform: "translate(-353.679 -188.984)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_142",
    "data-name": "Ellipse 142",
    cx: 1.62,
    cy: 1.62,
    rx: 1.62,
    ry: 1.62,
    transform: "translate(18.632)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1368",
    "data-name": "Group 1368",
    transform: "translate(64.71 194.673)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1367",
    "data-name": "Group 1367",
    transform: "translate(26.591 3.34)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_925",
    "data-name": "Path 925",
    d: "M184.636,350.089a13.241,13.241,0,0,1-2.678-.262l.307-1.462c3.05.638,8.028-.021,9.44-2.926a3.309,3.309,0,0,0-.021-2.882,3.477,3.477,0,0,0-2.175-1.813,8.331,8.331,0,0,0-5.951.977l-.734-1.3a9.8,9.8,0,0,1,7.119-1.1,4.98,4.98,0,0,1,3.074,2.57,4.829,4.829,0,0,1,.031,4.207C191.626,349.018,187.879,350.089,184.636,350.089Z",
    transform: "translate(-181.958 -339.032)",
    fill: "#bf0a40"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_395",
    "data-name": "Rectangle 395",
    d: "M0,0H24.272a0,0,0,0,1,0,0V7.282A12.136,12.136,0,0,1,12.136,19.417h0A12.136,12.136,0,0,1,0,7.282V0A0,0,0,0,1,0,0Z",
    transform: "translate(7.468)",
    fill: "#bf0a40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_926",
    "data-name": "Path 926",
    d: "M182.288,363.256H144.947a1.12,1.12,0,0,1-1.12-1.12h0a1.121,1.121,0,0,1,1.12-1.121h37.341a1.121,1.121,0,0,1,1.12,1.121h0A1.12,1.12,0,0,1,182.288,363.256Z",
    transform: "translate(-143.827 -342.345)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1373",
    "data-name": "Group 1373",
    transform: "translate(220.737 151.267)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1372",
    "data-name": "Group 1372"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1371",
    "data-name": "Group 1371",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1370",
    "data-name": "Group 1370"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1369",
    "data-name": "Group 1369"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_927",
    "data-name": "Path 927",
    d: "M390.955,311.258a4.1,4.1,0,0,1,1.709-3.168c1.509-.884,3.522-.146,5.278-.474,4.933-.923,4.9-7.809,4.8-11.6q-.1-3.619-.324-7.234a4.011,4.011,0,0,0-.423-1.851,2.735,2.735,0,0,0-3.072-.957c-2.159.617-3.371,2.949-3.754,5.162s-.2,4.513-.775,6.682a3.943,3.943,0,0,1-.48,1.163,2.671,2.671,0,0,1-1.08.922,2.11,2.11,0,0,1-2.006-.029c-.681-.437-.568-.987-.564-1.651a20.374,20.374,0,0,0-.2-2.418c-.209-1.813-.391-3.63-.561-5.447-.335-3.573-.626-7.149-1-10.719a12.23,12.23,0,0,0-1.173-4.786c-3.534-6.344-8.917-.771-9.412,3.855-1.126,10.525,4.356,20.45,3.9,30.9a3.144,3.144,0,0,1-.243,1.293c-.825,1.644-3.462,1.357-4.681.409-1.911-1.487-1.227-4.708-1.229-6.646,0-1.582-.508-3.369-2.038-4.11-1.735-.84-4,.167-4.988,1.718-1.276,2-1.134,5.428-.943,7.654a9.393,9.393,0,0,0,1.465,4.6,5.8,5.8,0,0,0,4.285,2.537c1.02.061,2.184-.155,2.958.456.943.744.6,2.105.642,3.243.074,2.259,2,4.19,4.244,5.14a21.9,21.9,0,0,0,7.25,1.255c2.094-3.36,2.234-7.234,2.343-10.99A40.356,40.356,0,0,1,390.955,311.258Z",
    transform: "translate(-367.563 -272)",
    fill: "#228f4e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_928",
    "data-name": "Path 928",
    d: "M391.574,272.546c2.515,17.455,4.683,35.222,1.587,52.6",
    transform: "translate(-374.829 -272.165)",
    fill: "none",
    stroke: "#19034d",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_929",
    "data-name": "Path 929",
    d: "M387.5,272.377a45.42,45.42,0,0,0-1.408,9.843c.031,6.32,2.693,12.364,3.739,18.611,1.169,6.979.3,14.092-.563,21.108",
    transform: "translate(-373.17 -272.114)",
    fill: "none",
    stroke: "#19034d",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_930",
    "data-name": "Path 930",
    d: "M395.931,309.5c3.038-.434,6.668-.872,8.589-3.308a3.573,3.573,0,0,0,.639-1.137c.508-1.652.254-3.524.247-5.221-.008-1.627.031-4.481.031-6.592",
    transform: "translate(-376.148 -278.43)",
    fill: "none",
    stroke: "#19034d",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_931",
    "data-name": "Path 931",
    d: "M386.944,327.181c-2.73.445-5.751.843-8.1-.5A6.751,6.751,0,0,1,375.9,323a13.59,13.59,0,0,1-.6-4.6,30.868,30.868,0,0,1,.431-5.048",
    transform: "translate(-369.904 -284.515)",
    fill: "none",
    stroke: "#19034d",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_932",
    "data-name": "Path 932",
    d: "M395.979,311.607a49.651,49.651,0,0,0,10.127-2.616,5.214,5.214,0,0,0,1.887-1.042,4.463,4.463,0,0,0,1-1.953c.478-1.578.679-12.382.152-15.02",
    transform: "translate(-376.163 -277.743)",
    fill: "none",
    stroke: "#19034d",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_934",
    "data-name": "Path 934",
    d: "M377.426,342.6l20.447-.435-2.083,15.227-15.606-.005Z",
    transform: "translate(-370.548 -293.234)",
    fill: "#f5ba00"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1375",
    "data-name": "Group 1375",
    transform: "translate(134.375 128.728)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_396",
    "data-name": "Rectangle 396",
    width: 89.782,
    height: 4.081,
    rx: 2.041,
    transform: "translate(0 83.622)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_935",
    "data-name": "Path 935",
    d: "M339.574,345.151H262.851l6.676-44.087a3.114,3.114,0,0,1,3.04-2.672h70.642a2.99,2.99,0,0,1,2.916,3.493Z",
    transform: "translate(-249.512 -257.448)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_143",
    "data-name": "Ellipse 143",
    cx: 3.673,
    cy: 3.673,
    r: 3.673,
    transform: "translate(55.026 57.504)",
    fill: "none",
    stroke: "#652f8c",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1374",
    "data-name": "Group 1374",
    transform: "translate(61.822)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_936",
    "data-name": "Path 936",
    d: "M333.048,282.677a26.951,26.951,0,0,1-.675-6.154,6.852,6.852,0,0,1,1.642-5.015,28.288,28.288,0,0,1,3.276-3.226,9.357,9.357,0,0,0,2.755-10.539",
    transform: "translate(-332.372 -245.146)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_937",
    "data-name": "Path 937",
    d: "M342.527,271.282c-.407-1.732.554-3.5,1.765-4.808a46.517,46.517,0,0,0,3.758-3.778c2.259-3.073,2.151-5.962,1.738-11.666-.291-4.011-.214-8.557,2.679-11.35",
    transform: "translate(-335.417 -239.68)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_397",
    "data-name": "Rectangle 397",
    width: 226.904,
    height: 4.897,
    rx: 2.449,
    transform: "translate(25.004 214.918)",
    fill: "#652f8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_938",
    "data-name": "Path 938",
    d: "M434.787,181.7c1.721,10.931,2.427,22.668-2.58,32.536-2.793,5.5-7.193,10.062-9.689,15.728-2.663,6.046-3.6,12.325-4.265,18.879",
    transform: "translate(-162.166 -93.405)",
    fill: "none",
    stroke: "#d2c8d9",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_939",
    "data-name": "Path 939",
    d: "M97.937,155.458c-6.968,8.414-17.317,13.184-25.683,20.208a60.339,60.339,0,0,0-21.208,46.667",
    transform: "translate(-51.035 -85.464)",
    fill: "none",
    stroke: "#d2c8d9",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_940",
    "data-name": "Path 940",
    d: "M337.26,55.352a43.2,43.2,0,0,1,25.955,23.006",
    transform: "translate(-137.655 -55.169)",
    fill: "none",
    stroke: "#d2c8d9",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_941",
    "data-name": "Path 941",
    d: "M109.686,389.788a94.086,94.086,0,0,0,55.683,23.019",
    transform: "translate(-68.785 -156.379)",
    fill: "none",
    stroke: "#d2c8d9",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_942",
    "data-name": "Path 942",
    d: "M329.11,393.148a116.881,116.881,0,0,0,10.936-5.6",
    transform: "translate(-135.189 -155.702)",
    fill: "none",
    stroke: "#d2c8d9",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_943",
    "data-name": "Path 943",
    d: "M256.13,406.957c14.832-.653,27.708-1.359,43.7-7.689",
    transform: "translate(-113.103 -159.248)",
    fill: "none",
    stroke: "#d2c8d9",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationPopupErrorGraphic);
export default __webpack_public_path__ + "static/media/notification-popup-error-graphic.40b894e44887e1b041c4576510979360.svg";
export { ForwardRef as ReactComponent };